type Props = {
  size: number;
};

const IconNext = ({size}: Props) => {
  return (
    <svg
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        d="M20.18 12.8L5.52.76a3.36 3.36 0 00-5.5 2.6v25.29a3.36 3.36 0 005.5 2.59L20.18 19.2a4.13 4.13 0 000-6.39zM25.12 0h6.86v32h-6.86z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconNext;
